export default {
  namespaced: true,
  state: {
    items: [],
    myItems: [],
    tries: [],
  },
  actions: {
    GetList({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'items', value: [] });
      return rootGetters.axl.post('specializations/api/specialization/list')
        .then((response) => {
          commit('setField', { name: 'items', value: response.data.items });
        }).catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
    GetMy({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'myItems', value: [] });
      return rootGetters.axl.post('specializations/api/specialization/my')
        .then((response) => {
          commit('setField', { name: 'myItems', value: response.data.items });
        }).catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
    GetTestTryList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'tries', value: [] });
      return rootGetters.axl.post('/specializations/api/test-try/list', payload)
        .then((response) => {
          commit('setField', { name: 'tries', value: response.data.tries });
        });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
